// extracted by mini-css-extract-plugin
module.exports = {"version":"Signup_version__3TuP_"};